// eslint-disable-next-line import/no-cycle
import { IShipmentListItem } from '@typings/shipment';
import { SortOption } from '../CustomizableTable/types';

export enum SortableColumnKey {
  Order = 'order',
  Package = 'package',
  Item = 'item',
  Receiver = 'receiver',
  Courier = 'courier',
  Tracking = 'tracking',
  CollectStatus = 'collectStatus',
  ImportTaxAndDuty = 'importTaxAndDuty',
  TotalCost = 'totalCost',
}

export type ShipmentColumnSortByKey =
  // Order
  | 'order_created_at'
  | 'platform_order_number'
  // Package
  | 'parcels_package_names_for_sorting'
  | 'parcels_count'
  | 'total_actual_weight'
  // Item
  | 'shipment_items_count'
  | 'unique_sku_count'
  | 'total_customs_value'
  // Receiver
  | 'destination_name'
  | 'destination_country_simplified_name'
  | 'postal_code'
  | 'state'
  // Courier
  | 'courier_display_name'
  | 'estimated_delivery_time'
  // Tracking
  | 'courier_tracking_rating'
  // Collect Status
  | 'collect_state'
  // Import Tax & Duty
  | 'import_tax_and_duty_sort_order'
  // Total Cost
  | 'total_charge';

export interface ShipmentsTableProps {
  shipments: IShipmentListItem[];
  isShipmentsLoading: boolean;
  totalShipmentsCount: number;
  openShipmentIndex: number;
  selectedShipmentsCount: number;
  onHeaderCheckboxChanged: (checked: boolean) => void;
  onAllShipmentsSelected: () => void;
  onAllShipmentsDeselected: () => void;
  onShipmentCheckboxChanged: (checked: boolean, index: number) => void;
  onOrderCellClick: (_: MouseEvent | null, index: number) => void;
  onReceiverCellClick: (_: MouseEvent | null, index: number) => void;
  onCourierCellClick: (_: MouseEvent | null, index: number) => void;
  onRefreshCellClick: () => void;
  onSort: (option: SortOption) => void;
}
